import request from '@/utils/request'

export function status (params) {
  return request({
    method: 'get',
    params: {
      r: 'user/state',
      ...params
    }
  })
}

export function getCustomerInfo () { //  客服api
  return request({
    method: 'get',
    params: {
      do: 'getCustomerInfo'
    }
  })
}
